module.exports = require("babel-preset-react-app/dependencies");